import { AccountTree, OpenWith, PlayArrow, Settings, Widgets } from '@mui/icons-material';

export type SubHeaderNavItemType = {
  label: string;
  icon: JSX.Element;
  to: string;
  count?: number;
};

export const matchingPaths = [
  '/packages/:packageId/:versionUuid/:entity/:entityId',
  '/packages/:packageId/:versionUuid/:entity'
];

export const getNavItems = (contentInfo: any): SubHeaderNavItemType[] => [
  {
    label: 'Package',
    icon: <Settings fontSize="small" />,
    to: 'package'
  },
  {
    label: 'Endpoints',
    icon: <OpenWith fontSize="small" />,
    to: 'endpoints',
    count: contentInfo?.endpoints
  },
  {
    label: 'Structures',
    icon: <Widgets fontSize="small" />,
    to: 'structures',
    count: contentInfo?.models
  },
  {
    label: 'Mappings',
    icon: <AccountTree fontSize="small" />,
    to: 'mappings',
    count: contentInfo?.mappings
  },
  {
    label: 'Flows',
    icon: <PlayArrow fontSize="small" />,
    to: 'flows',
    count: contentInfo?.flows
  }
];
